module.exports = __webpack_public_path__ + "img/pen-nib.6757d409.svg";